import React from "react";

export default function ChinaNewYearFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-3cn2{fill:#f2cf6b}.cls-3cn6{fill:#bc140f}.cls-3cn7{fill:#d12519}"
            }
          </style>
        </defs>
        <ellipse
          cx={1016.23}
          cy={844.61}
          rx={775.1}
          ry={789.05}
          style={{
            stroke: "#d12519",
            strokeWidth: "8.27px",
            fill: "none",
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={999.6}
          cy={853.94}
          r={728.95}
          style={{
            fill: "none",
            strokeMiterlimit: 10,
            stroke: "#f2cf6b",
            strokeWidth: "42.38px",
          }}
        />
        <ellipse
          cx={968.61}
          cy={915.73}
          rx={759.94}
          ry={737.94}
          style={{
            strokeWidth: "7.92px",
            stroke: "#d12519",
            fill: "none",
            strokeMiterlimit: 10,
          }}
        />
        <path
          d="m1575.1 1764.73-318.62 78.36c-50.9-95.49-147.26-159.91-257.76-159.91s-202.82 61.75-254.5 153.95l-320.11-87.81c65.68-272.09 297.64-473.17 573.72-473.17s516.76 208.7 577.27 488.57Z"
          className="cls-3cn7"
        />
        <path
          d="m746.094 1810.88 12.923-26.996 256.434 122.753-12.923 26.996z"
          className="cls-3cn7"
        />
        <path d="M982.98 1645.3h29.93v284.3h-29.93z" className="cls-3cn6" />
        <path
          d="m802.223 1732.404 21.164-21.163 201.03 201.03-21.163 21.164z"
          className="cls-3cn6"
        />
        <path
          d="m885.827 1674.64 27.401-12.04 114.365 260.283-27.402 12.04z"
          className="cls-3cn6"
        />
        <path
          d="m1002.1 1922.288-12.923-26.996 256.434-122.753 12.922 26.997z"
          className="cls-3cn6"
        />
        <path
          d="m1001.384 1922.072-21.164-21.164 201.03-201.03 21.164 21.163z"
          className="cls-3cn6"
        />
        <path
          d="m1004.534 1923.607-27.401-12.04 114.364-260.283 27.402 12.04z"
          className="cls-3cn6"
        />
        <circle cx={997.95} cy={1892.74} r={51.71} className="cls-3cn2" />
        <path
          d="M1049.65 1892.74c0 5.01-.71 9.84-2.04 14.42-6.23-21.55-26.1-37.3-49.66-37.3s-43.43 15.75-49.66 37.3a51.589 51.589 0 0 1-2.04-14.42c0-28.56 23.15-51.71 51.71-51.71s51.71 23.15 51.71 51.71Z"
          style={{
            fill: "#e2bb59",
          }}
        />
        <path
          d="M1038.57 1277.63c18.22 3.18 278.01 52.17 335.41 242.46 8.39 27.83 29.77 98.68-3.84 131.57-67.09 65.68-252.3-118.9-446.22-78.45-117.85 24.58-204.35 125.05-267.97 239.7l88.28 24.22c51.68-92.2 146.32-153.95 254.5-153.95s206.87 64.42 257.76 159.91l318.62-78.36c-57.57-266.25-273.47-468.08-536.53-487.1Z"
          className="cls-3cn6"
        />
        <path
          d="M1470.89 1790.95c-4.75 0-8.99-3.36-9.92-8.2 0-.01-1.42-3.34-14.01-7.52-10.06-3.34-23.46-6.02-36.43-8.61-30.9-6.17-57.59-11.5-63.87-27.94-6.47-16.92 10.15-39.12 29.38-64.83 7.59-10.14 15.44-20.63 20.59-29.46 6.17-10.57 5.82-14.3 5.71-14.85-.34-.29-3.26-2.52-15.8-2.08-10.46.36-23.77 2.44-36.63 4.44-31.32 4.88-58.36 9.09-70.03-4.28-11.83-13.55-3.94-40.01 5.2-70.65 3.65-12.24 7.42-24.9 9.21-35.04 2.12-12.05.49-15.43.19-15.94-.54-.2-4.15-1.13-15.54 3.56-9.62 3.96-21.29 10.46-32.58 16.75-27.75 15.47-51.72 28.82-67.38 20.32-15.7-8.53-17.6-35.95-19.8-67.71-.89-12.83-1.81-26.09-3.73-36.27-2.27-12.04-4.99-14.61-5.47-14.98-.6.02-4.32.55-13.16 8.95-7.47 7.1-15.94 17.27-24.12 27.11-20.37 24.47-37.97 45.6-55.72 43.39-17.49-2.18-29.3-26.71-42.97-55.12-5.66-11.77-11.52-23.94-17.18-32.78-5.97-9.33-9.39-11.3-10.43-11.7-.95.8-3.74 3.83-7.67 13.98-3.55 9.18-6.89 21.1-10.12 32.63-8.79 31.41-15.74 56.22-32.03 60.29-16.48 4.12-34.39-14.68-57.06-38.48-8.17-8.58-16.62-17.45-23.97-23.83-7.33-6.36-11.17-8.12-12.75-8.6-.71 1.49-2.03 5.51-2.3 15.26-.28 9.76.55 22.02 1.34 33.87 2.2 32.78 3.93 58.68-10.25 67.98-3.46 2.27-7.44 3.27-11.91 3.27-13.84 0-32.35-9.6-54.35-21.02-10.58-5.49-21.52-11.16-30.6-14.82-9.11-3.67-13.34-4.05-14.97-3.98-.2 1.62-.16 5.84 2.68 15.15 2.83 9.29 7.49 20.61 12 31.55 12.56 30.5 22.48 54.6 11.89 67.98-10.48 13.23-36.01 9.11-68.32 3.89-11.81-1.91-24.03-3.88-33.85-4.5-9.86-.63-14 .35-15.52.93.32 1.6 1.68 5.59 7.24 13.5 5.56 7.91 13.47 17.18 21.12 26.13 21.49 25.18 38.47 45.07 32.51 61.16-5.83 15.74-31.28 19.7-63.5 24.7-11.9 1.85-24.2 3.76-33.79 6.22-11.52 2.96-14.46 5.57-15.03 6.2-1.29 5.22-6.48 8.55-11.81 7.48-5.48-1.1-9.02-6.43-7.92-11.91 3.7-18.39 32.31-22.83 65.44-27.98 11.59-1.8 23.58-3.66 32.92-6.02 10.5-2.65 13.77-5.01 14.63-5.8-.1-1.16-.97-5.14-7.34-14.26-5.65-8.09-13.71-17.53-21.5-26.65-22.33-26.15-39.96-46.81-30.97-62.82 9.14-16.26 37.61-11.66 70.58-6.34 11.65 1.88 23.71 3.83 33.38 4.46 10.9.72 14.75-.54 15.8-1.03.25-1.13.65-5.18-2.57-15.78-2.85-9.39-7.55-20.81-12.1-31.85-13.14-31.91-23.52-57.12-9.92-69.59 13.71-12.57 38.03.05 68.83 16.03 10.52 5.46 21.4 11.1 30.42 14.74 10.2 4.11 14.24 4.1 15.39 3.96.59-.99 2.24-4.69 2.55-15.73.28-9.76-.54-22.03-1.34-33.9-2.32-34.57-4.15-61.88 12.84-69.36 16.97-7.48 35.81 12.31 59.67 37.36 8.22 8.63 16.72 17.55 24.11 23.96 8.38 7.26 12.23 8.53 13.35 8.75.88-.74 3.63-3.68 7.56-13.9 3.47-9.03 6.76-20.77 9.94-32.12 9.03-32.26 16.83-60.12 35.54-61.45 19.94-1.42 32.74 25.19 47.57 55.99 5.5 11.42 11.18 23.23 16.63 31.87 7.09 11.25 10.58 11.94 10.61 11.95.03 0 3.55.32 13.3-8.9 7.56-7.15 16.11-17.43 24.38-27.36 21.65-26 40.35-48.46 59.08-42.38 18.76 6.09 20.79 35.3 23.13 69.11.89 12.84 1.81 26.12 3.74 36.3 2.49 13.17 5.52 15.01 5.55 15.03.03.01 3.24 1.51 15.6-3.6 9.53-3.94 21.09-10.39 32.28-16.62 29.65-16.52 55.26-30.79 70.66-18.42 15.27 12.27 6.94 40.2-2.7 72.54-3.71 12.43-7.54 25.28-9.31 35.56-2.28 13.24-.06 15.99-.03 16.01.02.02 2.55 2.51 15.87 1.98 10.25-.41 23.24-2.43 35.81-4.39 33.64-5.24 62.69-9.77 72.92 7.24 10.03 16.69-7.35 39.92-27.48 66.82-7.8 10.43-15.87 21.21-21.11 30.3-6.76 11.74-5.59 15.16-5.58 15.19 0 .02 1.6 3.2 14.21 7.23 9.66 3.09 22.4 5.63 34.73 8.09 33.57 6.7 62.56 12.49 66.35 32.14 1.06 5.49-2.53 10.79-8.02 11.84-.65.12-1.29.18-1.92.18Zm-800.2-58.49Zm60.01-106.55Zm200.61-131.01Z"
          className="cls-3cn2"
        />
        <circle cx={559.44} cy={1687.33} r={19.18} className="cls-3cn2" />
        <circle cx={642.21} cy={1551.23} r={19.18} className="cls-3cn2" />
        <circle cx={764.22} cy={1445.34} r={19.18} className="cls-3cn2" />
        <circle cx={793.57} cy={1693.48} r={19.18} className="cls-3cn2" />
        <circle cx={739.87} cy={1773.65} r={19.18} className="cls-3cn2" />
        <circle cx={865.3} cy={1641.09} r={19.18} className="cls-3cn2" />
        <circle cx={950.93} cy={1617.73} r={19.18} className="cls-3cn2" />
        <circle cx={1044.03} cy={1614.78} r={19.18} className="cls-3cn2" />
        <circle cx={1137.14} cy={1641.09} r={19.18} className="cls-3cn2" />
        <circle cx={1205.34} cy={1696.95} r={19.18} className="cls-3cn2" />
        <circle cx={1266.17} cy={1768.27} r={19.18} className="cls-3cn2" />
        <circle cx={903.67} cy={1387.44} r={19.18} className="cls-3cn2" />
        <circle cx={1072.13} cy={1379.57} r={19.18} className="cls-3cn2" />
        <circle cx={1232.97} cy={1437.61} r={19.18} className="cls-3cn2" />
        <circle cx={1365.77} cy={1551.23} r={19.18} className="cls-3cn2" />
        <circle cx={1452.83} cy={1700.27} r={19.18} className="cls-3cn2" />
        {children}
      </g>
    </svg>
  );
}
